/**
 * CKC Temporary Competition Number (TCN) listing fee.
 *
 * A dog entered in a CKC event on a TCN pays this listing fee once per show in
 * addition to its class fees (CKC Conformation Show Rules 8.3.2). The amount is
 * set per event on the Sanctioning Club step (event.tcn_fee) and defaults to
 * CKC_TCN_FEE_DEFAULT, tax included.
 *
 * The fee appears in the transaction payment summary as a synthetic show
 * element line so the cart, summary and confirmation emails can show it
 * beside the dog's class fees.
 */
export const CKC_TCN_FEE_DEFAULT = 10.5;

export const CKC_TCN_FEE_LABEL = "TCN Listing Fee";
export const CKC_TCN_FEE_LEVEL = "TCN";
